/**
 * React Provider Component
 * 
 * A provider component that ensures React is available before rendering children.
 * This is a workaround for the useContext null issue.
 * 
 * @author Andres Nava
 * @version 1.0.0
 */

import React, { ReactNode, useEffect, useState } from 'react';// import { logger } from "../../utils/logger";
interface ReactProviderProps {
  children: ReactNode;
}

const ReactProvider: React.FC<ReactProviderProps> = ({ children }) => {
  const [isReactReady, setIsReactReady] = useState(false);

  useEffect(() => {
    // Ensure React is available globally immediately
    if (typeof window !== 'undefined') {
      (window as any).React = React;
      (globalThis as any).React = React;
      (global as any).React = React;
    }

    // Set React as ready immediately since we're already in a React component
    setIsReactReady(true);
  }, []);

  // Always render children - React is available since we're in a React component
  return <>{children}</>;
};

export default ReactProvider;
